import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Instagram, Mail, MapPin, Facebook } from 'lucide-react';
const FOOTER_BG = '#3D4A2F';
const FOOTER_BG_DARK = '#33402A';
export function SiteFooter() {
  return <footer className="pt-8 pb-5 text-[#E8E4D8]" style={{
    backgroundColor: FOOTER_BG
  }} data-id="element-2611">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-2612">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-6" data-id="element-2613">
          {/* Brand Col */}
          <div className="md:col-span-3" data-id="element-2614">
            <Link to="/" className="inline-flex items-center gap-3 mb-5" data-id="element-2615">
              <img src="https://cdn.magicpatterns.com/uploads/4gduygJNEAxYz3SyjoFAYx/ChatGPT_Image_May_13,_2026,_09_47_03_PM.png" alt="Structured Nutrition" className="w-14 h-14 object-contain" data-id="element-2616" />
              <div className="flex flex-col leading-tight" data-id="element-2617">
                <span className="text-base font-serif text-white tracking-wide" data-id="element-2618">
                  Structured
                </span>
                <span className="text-[10px] font-bold text-[#C8C4B0] uppercase tracking-[0.25em]" data-id="element-2619">
                  Nutrition
                </span>
              </div>
            </Link>
            <p className="text-sm text-[#C8C4B0] leading-relaxed max-w-xs mb-6" data-id="element-2620">
              Evidence-based nutrition coaching for real, sustainable health.
            </p>
            <div className="flex items-center gap-4" data-id="element-2621">
              <a href="#" aria-label="Facebook" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2622">
                <Facebook className="w-5 h-5" data-id="element-2623" />
              </a>
              <a href="#" aria-label="Instagram" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2624">
                <Instagram className="w-5 h-5" data-id="element-2625" />
              </a>
              <a href="mailto:jack@jackachenbach.com" aria-label="Email" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2626">
                <Mail className="w-5 h-5" data-id="element-2627" />
              </a>
            </div>
          </div>

          {/* Quick Links Col */}
          <div className="md:col-span-3" data-id="element-2628">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-2629">
              Quick Links
            </h4>
            <ul className="space-y-0.5" data-id="element-2630">
              {[{
              name: 'About',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Training',
              path: '/training'
            }, {
              name: 'Books',
              path: '/books'
            }, {
              name: 'Shop',
              path: '/shop'
            }, {
              name: 'Contact',
              path: '/contact'
            }].map(link => <li key={link.name} data-id="element-2631">
                  <Link to={link.path} className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2632">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services Col */}
          <div className="md:col-span-3" data-id="element-2633">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-2634">
              Services
            </h4>
            <ul className="space-y-0.5" data-id="element-2635">
              <li data-id="element-2636">
                <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2637">
                  1:1 GLP-1 Coaching
                </Link>
              </li>
              <li data-id="element-2638">
                <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2639">
                  Body Composition
                </Link>
              </li>
              <li data-id="element-2640">
                <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2641">
                  Off-Medication Strategy
                </Link>
              </li>
              <li data-id="element-2642">
                <Link to="/training" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2643">
                  Training App
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="md:col-span-3" data-id="element-2644">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-5" data-id="element-2645">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-2646">
              <li className="flex items-start gap-3" data-id="element-2647">
                <MapPin className="w-4 h-4 text-[#C8C4B0] mt-0.5 shrink-0" data-id="element-2648" />
                <span className="text-sm text-[#C8C4B0] leading-relaxed" data-id="element-2649">
                  Available nationwide
                  <br data-id="element-2650" />
                  Virtual coaching
                </span>
              </li>
              <li data-id="element-2651">
                <a href="mailto:jack@jackachenbach.com" className="flex items-center gap-3 text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2652">
                  <Mail className="w-4 h-4 shrink-0" data-id="element-2653" />
                  jack@jackachenbach.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-5 flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: FOOTER_BG_DARK
      }} data-id="element-2654">
          <p className="text-xs text-[#A8A492]" data-id="element-2655">
            © {new Date().getFullYear()} Jack Achenbach, MS, RDN, CPT. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-[#A8A492]" data-id="element-2656">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-2657">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-2658">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}